<template>
  <div id="container" class="effect aside-float aside-bright mainnav-out slide">
    <common-header :siderbar="false"></common-header>

    <div class="boxed">
      <div id="content-container">
        <div id="page-head">
          <hr class="new-section-sm bord-no" />
          <div class="welcome">
            <img
              src="../../../assets/images/avatar.png"
              class="img-circle img-xs"
            />
            <div>
              <span class="name">{{ userInfo.name }}</span>
              <span>欢迎回来！</span>
            </div>
          </div>
          <p class="last-login">
            上次登录时间：{{
              userInfo.last_login_at
                ? $time(userInfo.last_login_at).format('YYYY/MM/DD HH:mm')
                : '-'
            }}
          </p>
        </div>

        <div id="page-content">
          <h5 class="title">功能模块</h5>
          <div class="module-list">
            <div
              class="li"
              v-for="(item, index) in modules"
              :key="index"
              @click="moduleLogin(item)"
            >
              <div class="panel">
                <div class="panel-body text-center">
                  <div class="text-main module-icon">
                    <i class="icon-2x" :class="item.cover"></i>
                  </div>
                  <div
                    class="text-lg text-semibold mar-no text-main module-content"
                  >
                    <p class="module-name">{{ item.name }}</p>
                    <p class="desc">{{ item.desc }}</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <h5 class="title mt-30">最新消息</h5>

          <div class="notification">
            <p v-if="loaded && notifications.length == 0">暂无消息</p>
            <router-link
              :to="item.url"
              tag="p"
              class="nt"
              v-for="item in notifications"
              :key="item.id"
            >
              {{ $time(item.created_at).format('YYYY-MM-DD') }}
              [{{ item.function_module.short_name }}]
              {{ item.content }}
            </router-link>
          </div>
        </div>
      </div>
    </div>

    <footer id="footer">
      <p class="text-center">&#0169; {{ new Date().getFullYear() }} 海锐能源</p>
    </footer>
  </div>
</template>

	<script>
import '@/js/bootstrap.min.js'
import '@/js/nifty.min.js'
import CommonHeader from '@/components/Header'

import { getUserFunctionModules, notificationList } from '@/service/getData'
import { getStore } from '@/config/mUtils'

export default {
  data() {
    return {
      modules: [],
      userInfo: getStore('userInfo'),
      notifications: [],
      loaded: false,
    }
  },
  components: {
    CommonHeader,
  },
  created() {
    this.initData()
    this.getNotifications()
  },
  methods: {
    async initData() {
      let res = await getUserFunctionModules()
      if (res.status == 0) {
        this.modules = res.data
      }
    },

    async getNotifications() {
      let res = await notificationList({ status: 1 })
      if (res.status == 0) {
        this.notifications = res.data.list
        this.loaded = true
      }
    },

    async moduleLogin(item) {
      this.$router.push(item.url)
    },
  },
}
</script>

<style scoped>
#content-container {
  width: 960px;
  margin: 0 auto;
  padding-left: 20px;
  padding-right: 20px;
}
#page-head {
  margin-bottom: 50px;
}
#page-content {
  padding: 0 !important;
}
.module-list {
  display: flex;
  flex-wrap: wrap;
}

.module-list .li {
  width: 30%;
  margin-right: 5%;
  margin-bottom: 30px;
  cursor: pointer;
}

.module-list .li:nth-child(3n) {
  margin-right: 0;
}
.panel-body {
  display: flex;
  align-items: center;
  padding: 0 !important ;
}
.panel {
  margin-bottom: 0;
  border-radius: 10px;
}
.title {
  margin-bottom: 20px;
  color: #bfc5cf;
  font-size: 26px;
  letter-spacing: 1px;
  font-weight: 400;
}
.welcome {
  display: flex;
  align-items: center;
  /* font-weight: bold; */
  font-size: 1.2em;
  color: #333;
}
.welcome .name {
  font-size: 1.4em;
  margin-right: 12px;
  margin-left: 10px;
}
.last-login {
  padding-left: 50px;
  font-size: 1.1em;
  opacity: 0.8;
  color: #999;
}

.img-xs {
  width: 40px;
  height: 40px;
}
.module-icon {
  background: #ebeff5;
  border-radius: 50%;
  text-align: center;
  width: 56px;
  height: 56px;
  display: flex;
  justify-content: center;
  align-items: center;
}
.module-content {
  margin-left: 15px;
  font-weight: 400;
  color: #1a2334;
}

.module-content p {
  margin-bottom: 0;
  text-align: left;
}
.module-content p.module-name {
  font-size: 1.4em;
}
.module-content p.desc {
  margin-top: 4px;
  font-size: 12px;
}
.notification {
  font-size: 14px;
  padding-left: 2px;
}
.notification p.nt {
  cursor: pointer;
  width: 65%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  color: #333;
}

.notification p.nt:hover {
  text-decoration: underline;
  color: #000;
}
</style>